<template>
<!--  <ol class="breadcrumb" style="position: fixed;z-index: 1;width: 81%;">-->
  <ol class="breadcrumb" style="padding-left: 1.2rem">
    <li class="breadcrumb-item" v-for="(item, index) in list">
      <span class="active" v-if="isLast(index)">{{ showName(item) }}</span>
     <!-- <router-link :to="item.path" v-else-if="item.path!==''">{{ showName(item) }}</router-link>-->
      <span v-else-if="item.path!==''">{{ showName(item) }}</span>
      <a href="#/" @click="goHome" v-else-if="item.path===''">{{ showName(item) }}</a>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    },
    separator: String
  },
  methods: {
    isLast (index) {

      return index === this.list.length - 1
    },
    showName (item) {
   /*   console.log(this.list)*/
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item
    },
      goHome(){
          this.$router.push({path:'/dashboard'});
      }
  }
}
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?77078158